import { createFileRoute } from "@tanstack/react-router"

import { Spinner } from "@/components/ui/spinner"
import { requireAdminBeforeLoad } from "@/lib/auth-guard"

export const Route = createFileRoute("/_authed/_admin")({
  beforeLoad: async ({ context, location }) => {
    await requireAdminBeforeLoad({ context, location })
  },
  pendingComponent: () => (
    <div className="flex items-center justify-center py-20" role="status">
      <Spinner className="size-6" />
      <span className="sr-only">Verifying admin access...</span>
    </div>
  ),
  pendingMs: 200,
  pendingMinMs: 300,
})
